/**
 * Initializes and authenticates a WebSocket connection to the DigiTickets 'socket' server.
 * Used for kitchen and kitchen-customer screens to receive instant updates pushed from the app server via
 * the socket.
 *
 * @constructor
 *
 * @param {ApiClient} apiClient
 */
const OrderFulfillmentService = function (
    apiClient,
) {
    this.apiClient = apiClient;
};

OrderFulfillmentService.prototype = {
    /**
     * @param {KitchenOrder} order
     */
    markAsFulfilled(order) {
        // Send the list of fulfilled items to the API.
        // These are only the items that are visible on the current screen - we don't want to just
        // mark everything in the order as fulfilled.

        const requestData = {};

        const visibleItems = order.getVisibleItems();

        // Build the list of *additional* fulfilled items to add to the order's fulfillment.
        const additionalFulfilledItems = visibleItems
            .filter((item) => item.versionIndex === 0)
            .map((item) => ({
                itemID: item.itemID,
                qty: item.qtyUnfulfilled,
                hash: item.hash,
                fulfilledAt: new Date(),
                fieldData: Object.values(item.fieldData).map((fd) => ({
                    fieldID: fd.fieldID,
                    value: fd.answer.join(','),
                })),
            }))
            .filter((itemFulfillmentRequest) => {
                // Skip any items that have no additional fulfilled qty.
                return itemFulfillmentRequest.qty > 0;
            });
        requestData.additionalFulfilledItems = additionalFulfilledItems;

        // Mark the individual lines as fulfilled
        visibleItems.forEach((item) => {
            // FIXME: This may break when combined with setFulfillments cloning items.
            if (!item.isFulfilled) {
                item.qtyFulfilled += item.qtyUnfulfilled;
                item.isFulfilled = true;
            }
        });

        // If the order only contains items visible on the current screen, then we can
        // already know that this order is completely fulfilled once order away is pressed.
        const fullyVisibleFulfillment = order.totalFulfilledItemQty === order.totalItemQty;
        if (fullyVisibleFulfillment) {
            order.fulfilledAt = new Date();
            requestData.fulfilledAt = new Date();
        }

        return this.apiClient
            .request(
                'PATCH',
                `orders/${order.orderID}/fulfillments`,
                requestData,
            )
            .then(({ data }) => {
                console.log('PATCH fulfillments result', data);
                return data;
            });
    },
};

module.exports = OrderFulfillmentService;
